export * from './advanceSearchNormalResultEnty.component';
